import { default as card } from "./card";
import CardBody from "./cardBody";
import CardFooter from "./cardFooter";
import CardHeader from "./cardHeader";
import CardSubTitle from "./cardSubTitle";
import CardTitle from "./cardTitle";

import collapsibleCard from "./collapsible/card";
import CollapsibleCardBody from "./collapsible/cardBody";
import CollapsibleCardHeader from "./collapsible/cardHeader";

export type { CardProps } from "./card";
export type { CardBodyProps } from "./cardBody";
export type { CardFooterProps } from "./cardFooter";
export type { CardHeaderProps } from "./cardHeader";
export type { CardSubTitleProps } from "./cardSubTitle";
export type { CardTitleProps } from "./cardTitle";

const Card = Object.assign(card, {
  Collapsible: collapsibleCard,
  Header: Object.assign(CardHeader, {
    Collapsible: CollapsibleCardHeader,
  }),
  Title: CardTitle,
  Body: Object.assign(CardBody, {
    Collapsible: CollapsibleCardBody,
  }),
  Footer: CardFooter,
  SubTitle: CardSubTitle,
});

export const CollapsibleCard = Object.assign(collapsibleCard, {
  Header: CollapsibleCardHeader,
  Title: CardTitle,
  Body: CollapsibleCardBody,
  Footer: CardFooter,
  SubTitle: CardSubTitle,
});

export default Card;
